import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceEmailEndpointSchema } from './validations';

/**
 * Fetches the email file for a specific invoice by invoice ID and file ID.
 *
 * @param invoiceId - The ID of the invoice to fetch the email for.
 * @param fileId - The ID of the file to fetch.
 * @param options - The options for the request (includes abort signal).
 * @returns The invoice email as a Blob.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_invoice_file
 */
export const fetchInvoiceEmail = async (
  invoiceId: UUID,
  fileId: UUID,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .get(ENDPOINT.INVOICE.GET_EMAIL(invoiceId, fileId), {
      validate: {
        pathSegments: zodInvoiceEmailEndpointSchema,
      },
      ...options,
    })
    .blob();

  return response;
};
